import { useEffect, useRef, useState } from 'react'
import { fieldFormExternal, fieldFormInfoEmployee } from '../helper';
import { FormValues } from '../models/IFormValues';
import { useDispatch, useSelector } from 'react-redux';
import {  apiInstance, Dispatch, GET_DATA_MONTH, GET_DATA_YEAR, GET_ELECTRONIC_DOCS, RootState } from 'shared';
import { FormikProps } from 'formik';
import { IDataApiFields, IYearItem } from '../models/IDataApiFields';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import { useAuth } from 'shared/auth';
import { downloadDocument, downloadsDescription, downloadsTitle } from 'shared/utils';
import { apiInstanceMunicipios } from 'shared/api/config/apiInstanceMunicipios';

export const useFormExternal = () => {

  const {authService} = useAuth();
  const apikeyCatpcha = process.env.REACT_APP_RECAPTCHA!;
  const formikRef = useRef<FormikProps<any>>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [dataFields, setDataFields] = useState<any[]>([]);
  const [dataEmployees, setDataEmployees] = useState<any[]>([])
  const dispatch = useDispatch<Dispatch>();
  const {departments, cities} = useSelector((state: RootState) => state.optionsDropdowns);
  const [ dataApiFields, setDataApiFields ] = useState<IDataApiFields>({});
  const [ isButtonDisabled, setIsButtonDisabled ] = useState<boolean>(true);
  const { id, originalName, isLoadingLinkDocument } = useSelector((state: RootState) => state.linkDocument);
  const [isLoading, setIsLoading] = useState(false)
  const [ resolution3374Document, setResolution3374Document ] = useState<any>(null);
  
  useEffect(() => {
    setIsLoading(isLoadingLinkDocument ?? false);
  },[isLoadingLinkDocument])

  useEffect(() => {
    const fields = fieldFormExternal(dataApiFields)
    const fieldsInfo = fieldFormInfoEmployee()
    setDataFields(fields)
    setDataEmployees(fieldsInfo)
  }, [cities, dataApiFields])

  useEffect(() => {
    Object.keys(departments).length === 0 &&  dispatch.optionsDropdowns.getDepartments();
  },[departments])
  
  useEffect(() => {
    const idDepartment = departments?.find((department) => department.name == 'ANTIOQUIA')?.id;
    idDepartment && dispatch.optionsDropdowns.getCities(idDepartment);
  }, [departments.length > 0])

  useEffect(() => {
    async function fetchData() {
      const responseYear = await apiInstance.get<IYearItem[]>(GET_DATA_YEAR);
      const responseMonth = await apiInstance.get(GET_DATA_MONTH);
      const filteredYears = responseYear.data.filter((year:IYearItem )=> {
        const numericYear = Number(year.name);
        return !isNaN(numericYear) && numericYear >= 2025
      })
      setDataApiFields((prev) => ({...prev, responseYear: filteredYears, responseMonth: responseMonth.data}))
    }
    fetchData()
    console.log("🚀 ~ useFormExternal ~ apikeyCatpcha:", apikeyCatpcha)
  },[])

  useEffect(() => {
    cities.length > 0 && setDataApiFields((prev) => ({...prev, cities}))
  },[cities])

  const onChangeReCaptcha = () =>{
    if(recaptchaRef.current?.getValue()){
      setIsButtonDisabled(false)
    }else{
      setIsButtonDisabled(true)
    }
  }
      
  const handleChangeFile = (file: any, formik: FormikProps<FormValues>) => {

    if (formik.values.itemformCity) {
      dispatch.linkDocument.getLinkAsync({
        file: file,
        url: `${GET_ELECTRONIC_DOCS}/${formik.values.itemformCity}/rips/generate-upload-link`,
      }).then((response) => {
        setResolution3374Document(file);
        formik.setFieldValue('resolution3374Document', file)
      }).catch(() => {
        dispatch.linkDocument.cleanAllState();
        setResolution3374Document(null);
        formik.setFieldValue('resolution3374Document', null)
      })
    }else{
      setIsLoading(false);
      Swal.fire({
        title: '¡Por favor selecciona un Municipio antes de cargar el archivo!',
        icon: 'warning',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      })
    }
  }

  const initialValues: FormValues = {
    itemformCity: '',
    codeDane: '',
    dateYear: '',
    dateMonth: '',
    termsOfService: false,
    resolution3374Document: null,
    emailUser: '',
    confirmEmail: '',
    phone: '',
    names: '',
    role: '',
  };

  const checkUploadFile = async (responseId: number, itemformCity: string, actions: any) => {
    try {
      const response = await apiInstanceMunicipios.get(`${GET_ELECTRONIC_DOCS}/${itemformCity}/rips/city/${responseId}`);
   
      if (response.status === 202) {
        setTimeout(() => checkUploadFile(responseId, itemformCity, actions), 12000);
      } else if((response.data === 'FAILED')) {
        Swal.fire({
            title: downloadsTitle.errorRips,
            text: response.data,
            icon: 'error',
            timer: 8500,
          });
        setIsLoading(false);
      }else{
        response.status === 206
        ? downloadDocument(response, downloadsTitle.errorRips, downloadsDescription.errorRips, 'error')
        : Swal.fire({
            title: 'Carga exitosa',
            text: 'El archivo se ha procesado correctamente.',
            icon: 'success',
            timer: 8500,
          }).then(() => {
            actions.resetForm();
            actions.setSubmitting(false);
          });
        setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error)
      }
  }

  const submitHandler = async(values: FormValues, actions: any) => {
    setIsLoading(true);
    await apiInstanceMunicipios.post(`${GET_ELECTRONIC_DOCS}/${values.itemformCity}/rips/city`, {
      attachmentId: id,
      email: values.emailUser,
      yearId: parseInt(values.dateYear),
      monthId: parseInt(values.dateMonth),
      daneCode: values.codeDane,
      phone: values.phone,
      firstName: values.names.split(' ')[0],
      lastName: values.names.split(' ').slice(1).join(' ') ?? '',
      positionRole: values.role,
    })?.then((response) => {
      if(response?.status === 202){
        checkUploadFile(response.data.id, values.itemformCity, actions);
      }
    })
    .catch((error) => {
      setIsLoading(false);
      dispatch.linkDocument.cleanAllState()
      Swal.fire({
        title: '¡Error al cargar el documento!',
        text: error?.response?.data?.message || 'Error inesperado',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(() => {
        actions.setSubmitting(false);
      })
    })
  };

  const onLogout = () => {
    authService.logout();
  }

  return {
    dataFields,
    initialValues,
    dataEmployees,
    submitHandler,
    formikRef,
    handleChangeFile,
    onChangeReCaptcha,
    apikeyCatpcha,
    recaptchaRef,
    isButtonDisabled,
    dispatch,
    isLoading,
    resolution3374Document,
    originalName,
    setResolution3374Document,
    onLogout
  }
    
}
